const data = [
    {
        id: "1",
        title: "How can I open an account?",
        message: "Opening an account with Fastest is simple and secure. Visit our website, click on 'Sign Up', fill in your personal details, verify your email address, and complete our identity verification process. The whole process typically takes less than 5 minutes.",
    },

    {
        id: "2",
        title: "Sending Money",
        message: "To send money, log into your account, select 'Send Money', choose your recipient's currency, enter the amount, and confirm the exchange rate. We support multiple payment methods including bank transfer, credit/debit cards, and digital wallets.",
    },

    {
        id: "3",
        title: "How are the exchange rates determined?",
        message: "Our exchange rates are updated in real-time based on the global foreign exchange market. We source our rates from multiple major banks and financial institutions to ensure you get competitive rates. Rates are refreshed every 60 seconds.",
    },

    {
        id: "4",
        title: "Are there any fees associated with using Fastest?",
        message: "We maintain transparent pricing with no hidden fees. Our fee structure includes a small conversion fee (typically 0.5-1% of the transaction amount) and any applicable network fees. Large volume transactions may qualify for reduced rates.",
    },

    {
        id: "5",
        title: "Which currencies can I buy on Fastest?",
        message: "We support over 50 major currencies including USD, EUR, GBP, JPY, AUD, CAD, and many more. You can also trade popular cryptocurrencies like Bitcoin, Ethereum, and other major altcoins. Check our currency list for the complete selection.",
    },
]

export default data;